<template>
  <b-container class="home-container container-xl">
    <b-row class="wrapper-3" cols="12">
      <b-col cols="12" md="12" class="left-side pt-5">
        <h1 class="top-title mb-4">Demján Sándor Tanácsadási Voucher Program</h1>
      </b-col>
      <b-col class="pb-3 pr-5 pl-5" cols="12" md="12">
        <div class="firstDiv B">
          <p class="p1-kkv">
            Magyarország Kormánya a Demján Sándor Program részeként hirdette meg a kkv-k méretnövekedését elősegítő
            Demján Sándor Tőkeprogramot, melynek célja a hazai kis- és középvállalkozások beruházásainak támogatása,
            különös tekintettel a kapacitásbővítésre, digitalizációs fejlesztésekre, energiahatékonysági beruházásokra,
            valamint a vállalkozásfejlesztéshez kapcsolódó beruházásokra.
            <br />
            A programról részletes információ és jelentkezési lehetőség a
            <a href="https://demjantokeprogram.hu" target="_blank">https://demjantokeprogram.hu</a> oldalon érhető el.
          </p>
          <p class="p1-kkv">
            A fenti célok elérése érdekében a Magyar Gazdaságfejlesztési Ügynökség Közhasznú Nonprofit Korlátolt
            Felelősségű Társaság (továbbiakban: MGFÜ) részéről Demján Sándor Tanácsadási Voucher Program kerül
            bevezetésre, amelynek célja, hogy támogassa a kis- és középvállalkozásokat tanácsadási szolgáltatások
            igénybevételében, előre meghatározott témakörökben, annak érdekében, hogy a KKV tőkefinanszírozási
            programban a tőkebevonást előkészítsék.
          </p>
          <p class="p1-kkv">
            A tanácsadási szolgáltatás igénybevételéhez az MKIK az MGFÜ és a MKIK Tőkealap-kezelő Zrt. közreműködésével
            vissza nem térítendő támogatást biztosít a hazai vállalkozások számára.
          </p>
        </div>
      </b-col>
    </b-row>
    <b-container class="wrapper-4 text-left">
      <b-row class="box-top p-5 mb-md-5">
        <b-col class="B pb-2" cols="12" lg="5">Pályázók köre:</b-col>
        <b-col class="pb-2" cols="12" lg="7">
          mikro-, kis- és középvállalkozások, amelyek megfelelnek az MKIK Tőkealap-kezelő Zrt. által meghirdetett Demján
          Sándor Tőkeprogram felhívásában foglaltaknak.
        </b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Meghirdetés dátuma:</b-col>
        <b-col class="pb-2" cols="12" lg="7">2025.04.03.</b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Támogatás maximum összege:</b-col>
        <b-col class="pb-2" cols="12" lg="7">3 802 680 Ft </b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Támogatási intenzitás:</b-col>
        <b-col class="pb-2" cols="12" lg="7">50-80%</b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Támogatható tevékenységek:</b-col>
        <b-col class="pb-2" cols="12" lg="7">
          A felhívás keretében csak és kizárólag stratégiai és vállalati pénzügyi tanácsadási szolgáltatás igénybevétele
          támogatható.
        </b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Keretösszeg:</b-col>
        <b-col class="pb-2" cols="12" lg="7">450 000 000 Ft</b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Projekt megvalósításának határideje:</b-col>
        <b-col class="pb-2" cols="12" lg="7">A Támogatói Okirat hatálybalépésétől számított maximum 90 nap</b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Benyújtási időszak kezdete:</b-col>
        <b-col class="pb-2" cols="12" lg="7">2025.04.14.</b-col>
        <hr class="decorative-line" />
        <b-col class="B pb-2" cols="12" lg="5">Benyújtási időszak vége:</b-col>
        <b-col class="pb-2" cols="12" lg="7">2026.07.31.</b-col>
      </b-row>
    </b-container>
    <h1 class="m-4">Pályázás ütemezése</h1>
    <b-container class="application-process-container mt-5">
      <b-row>
        <!-- Bal oldali oszlop (1-8) -->
        <b-col cols="12" md="6">
          <div class="step-line-left"></div>
          <b-row>
            <b-col v-for="step in steps.slice(0, 8)" :key="step.number" cols="12" class="step-item mt-3 mb-3">
              <div class="step-number dot">
                {{ step.number }}
                <ChevronDownIcon :size="21" class="text-left black" />
              </div>
              <p class="step-description">{{ step.description }}</p>
            </b-col>
          </b-row>
        </b-col>

        <!-- Jobb oldali oszlop (9-17) -->
        <b-col cols="12" md="6">
          <b-row>
            <div class="step-line-right"></div>
            <b-col v-for="step in steps.slice(8, 17)" :key="step.number" cols="12" class="step-item mt-3 mb-3">
              <div class="step-number dot">
                {{ step.number }}
                <ChevronDownIcon v-if="step.number < 17" :size="21" class="text-left black" />
              </div>
              <p class="step-description">{{ step.description }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-button
          variant="primary"
          href="https://vali.hu/static/DEMJAN_Folyamatabra_2025_1019.pdf"
          target="_blank"
          class="step-button"
        >
          Részletes folyamat ismertető letöltése
        </b-button>
      </b-row>
    </b-container>
    <b-row>
      <b-col>
        <b-button
          class="bigButton mt-3 pt-3 buttonSroll"
          @click="openLink(' https://dstvoucherprogram.vali.hu/')"
          target="_blank"
        >
          <h2 class="greenH">
            <span class="left-span ml-4 buttonFont">Tovább a pályázói felületre</span>
            <ChevronRightIcon :size="45" class="text-right arrow-1" />
          </h2>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <DocumentAccordion
          title="Pályázati dokumentumok"
          :documents="accordionItemsFirst[0].documents"
          v-model="isActiveFirst"
          target="_blank"
          @toggle="toggleIsActiveFirst"
        />
      </b-col>
    </b-row>
    <!--b-container>
      <b-row>
        <b-col>
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <b-col class="d-flex align-items-center justify-content-between mt-5 mb-5">
                <h3 class="B button-title text-center flex-grow-1">Módosítások nyomon követése</h3>
                <img src="../assets/img/icons/download-black.svg" style="width: 24px; height: 24px;" />
              </b-col>
            </b-card-header>
          </b-row>
        </b-col>
      </b-row>
    </b-container-->
    <b-container>
      <b-row>
        <b-col class="mt-3">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role mb-3">
              <b-col class="d-flex align-items-center justify-content-between mt-4 mb-4">
                <h3 class="B button-title text-center flex-grow-1">Pályázati hírek</h3>
              </b-col>
              <b-col class="text-left">
                <p>
                  Felhívjuk tisztelt támogatást igénylőink figyelmét, hogy 2026. április 29-én a felhívás az alábbi főbb
                  pontokban módosult:
                </p>
                <ul>
                  <li>
                    A pályázatok benyújtási határideje 2026. július 31-ig meghosszabbodott.
                  </li>
                </ul>
                <p>
                  A módosítás részletei a Pályázati dokumentumok menüpont alatt érhető el.
                </p>
              </b-col>
            </b-card-header>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <b-col>
        <DocumentAccordion
          title="Archív dokumentumok"
          :documents="accordionItemsThird[0].documents"
          v-model="isActiveThird"
          target="_blank"
          @toggle="toggleIsActiveThird"
        />
      </b-col>
    </b-row>
    <b-container>
      <b-row>
        <b-col class="mb-4">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button
                @click="openLink('https://vali.hu/static/Hatalyos_TO_DSTVP_20260330.pdf')"
                download
                class="buttonScroll buttonRight"
              >
                <span class="B left-span" style="font-size: 29px;">Támogatott vállalkozások</span>
                <img src="../assets/img/icons/download.svg" class="modositas_icon" />
              </button>
            </b-card-header>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <b-col class="mt-3">
        <b-button
          class="bigButton mt-1 buttonScroll buttonTOV d-flex align-items-center justify-content-between svgLeft"
          @click="openLink('/fund-map')"
          target="_blank"
        >
          <h2 class="greenH d-flex align-items-center ml-2 mb-0">
            <img
              src="../assets/img/támogatások.svg"
              alt="Támogatások"
              class="mr-3"
              style="max-width: 30px; height: auto;"
            />
            <span class="left-span buttonFont">TOVÁBBI PÁLYÁZATI LEHETŐSÉGEK</span>
            <ChevronRightIcon :size="45" class="arrow-2" />
          </h2>
        </b-button>
      </b-col>
    </b-row>
    <b-container>
      <!-- Itt van az iFrame -->
      <b-col cols="12" lg="12" class="mt-5 mb-5 pt-3 pb-2">
        <h2 class="text-center mb-4">Böngésszen minősített tanácsadóink között:</h2>
        <iframe
          src="https://vali.mgfu.hu/rest/experts/kat3"
          style="width: 100%; height: 80vh; border: none;"
          title="Szakértők elérhetősége"
        >
        </iframe>
      </b-col>
    </b-container>
    <b-container>
      <h2 class="font-weight-bold mb-2 mt-4">Ügyfélszolgálat elérhetősége</h2>
      <b-row class="mb-5">
        <b-col class="Box_padding" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-2 wrapper pt-3 pb-2">
                <p class="greenText pt-1 mb-2">Ügyfélszolgálat várja megkeresését az alábbi munkarendben:</p>
                <p class="mb-1">Hétfőtől csütörtökig: 8:00 – 17:00</p>
                <p>Pénteken: 8:00 – 14:30</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col class="Box_padding mb-4" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-2 wrapper pt-3 pb-2">
                <p class="greenText pt-1 mb-2">Ügyfélszolgálat elérhetősége:</p>
                <p class="mb-1"><img class="mr-2" src="../assets/img/icons/homephone.svg" /> +36 1 312 2213</p>
                <p>
                  <img class="mr-2" src="../assets/img/icons/envelope.svg" />
                  <a href="mailto:info@mgfu.hu">info@mgfu.hu</a>
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <DemjanSandorProgram />
  </b-container>
</template>
<script>
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import DocumentAccordion from './DocumentAccordion.vue' // Új komponens
import DemjanSandorProgram from './DemjanSandorProgram.vue' // Importálás

export default {
  components: {
    ChevronRightIcon,
    ChevronDownIcon,
    DocumentAccordion,
    DemjanSandorProgram
  },
  data() {
    return {
      isActiveFirst: false,
      isActiveSecond: false,
      isActiveThird: false,
      accordionItemsFirst: [
        {
          documents: [
            {
              text: 'Felhívás Demján Sándor Tanácsadási Voucher Program',
              url: 'https://vali.hu/static/Demjan_Sandor_Tanacsadasi_Voucher_Program_felhivas_260429.pdf'
            },
            {
              text: 'Adatkezelési tájékoztató Demján Sándor Tanácsadási Voucher Program',
              url: 'https://mgfu.hu/hu/page/privacy-policy'
            },
            {
              text: 'Változásjegyzék Demján Sándor Tanácsadási Voucher Program',
              url: 'https://vali.hu/static/Valtozasjegyzek_Demjan_Sandor_Tanacsadasi_Voucher_Program.pdf'
            }
          ]
        }
      ],
      accordionItemsSecond: [
        {
          documents: [
            {
              text: 'Pályázati felhívás (archív)',
              url: 'https://vali.hu/static/Felhivas_mod_KKV_Energiakoltseg_Tamogatasi_Program_archiv.pdf'
            },
            {
              text: 'Kitöltési útmutató - szálláshely, vendéglátás',
              url: 'https://vali.hu/static/palyazati_felulet-kitoltesi_utmutato_feldolgozoipar.pdf'
            },
            {
              text: '“A” Pályázás menete - szálláshely, vendéglátás',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_A_szalloda_vendeglatas.pdf'
            },
            {
              text: '“A” Pályázás menete - feldolgozóipar',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_A_feldolgozo-ipar.pdf'
            },
            {
              text: '“B” Pályázás menet - szállás',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_B_szalloda_vendeglatas.pdf'
            },
            {
              text: '“B” Pályázás menete - feldolgozóipar',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_B_feldolgozo-ipar.pdf'
            },
            {
              text: '“A” Költségtámogatás ismertető - szállás',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_A_koltsegtamogatas_ismerteto_szalloda_vendeglatas.pdf'
            },
            {
              text: '“A” Költségtámogatás ismertető - feldolgozóipar',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_A_koltsegtamogatas_ismerteto_feldolg_ipar.pdf'
            },
            {
              text: '“B” Önerő támogatás ismertető - szállás',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_B_onero_tamogatas_ismerteto_szalloda_vendeglatas.pdf'
            },
            {
              text: '“B” Önerő támogatás ismertető - feldolgozóipar',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_B_onero_tamogatas_ismerteto_feldolgozo-ipar.pdf'
            },
            {
              text: 'GYIK -szálláshely, vendéglátás',
              url: 'https://vali.hu/static/GYIK_Szallashely_vendeglatas.pdf'
            },
            {
              text: 'GYIK – feldolgozóipar',
              url: 'https://vali.hu/static/GYIK_Feldolgozoipari.pdf'
            },
            {
              text: 'Egyéni vállalkozó nyilatkozata',
              url: 'https://vali.hu/static/Egyeni_vallalkozo_nyilatkozata_MGFU.docx'
            },
            {
              text: 'Jogi személy nyilatkozata',
              url: 'https://vali.hu/static/Jogi_szemely_nyilatkozata_MGFU.docx'
            },
            {
              text: 'Összeférhetetlenségi nyilatkozat',
              url: 'https://vali.hu/static/osszeferhetetlensegi_nyilatkozat_MGFU.xlsx'
            },
            {
              text: 'Bankszámlaszámokról szóló nyilatkozat',
              url: 'https://vali.hu/static/Bankszamlaszamokrol_szolo_nyilatkozat_MGFU.docx'
            },
            {
              text: 'Meghatalmazás',
              url: 'https://vali.hu/static/Meghatalmazas_MGFU.docx'
            },
            {
              text: 'Felhatalmazó levél',
              url: 'https://vali.hu/static/Energiatamogatas_Felhat_level_sablon_MGFU.docx'
            }
          ]
        }
      ],
      accordionItemsThird: [
        {
          documents: [
            {
              text: 'Felhívás Demján Sándor Tanácsadási Voucher Program 2025.04.03',
              url: 'https://vali.hu/static/Demjan_Sandor_Tanacsadasi_Voucher_Program_felhivas_0403.pdf'
            },
            {
              text: 'Felhívás Demján Sándor Tanácsadási Voucher Program 2025.08.01',
              url: 'https://vali.hu/static/Demjan_Sandor_Tanacsadasi_Voucher_Program_felhivas_0801.pdf'
            },
            {
              text: 'Felhívás Demján Sándor Tanácsadási Voucher Program 2025.11.24.',
              url: 'https://vali.hu/static/Demján_Sándor_Tanácsadási_Voucher_Program_felhívás_251124.pdf'
            },
            {
              text: 'Felhívás Demján Sándor Tanácsadási Voucher Program 2026.02.27.',
              url: 'https://vali.hu/static/Demjan_Sandor_Tanacsadasi_Voucher_Program_felhivas_260227.pdf'
            }
          ]
        }
      ],
      steps: [
        {
          number: 1,
          description: 'Regisztráció a Tőkeprogramba'
        },
        {
          number: 2,
          description: 'Jogosultsági kritériumok automatizált ellenőrzése'
        },
        {
          number: 3,
          description: 'Szakértői szerződés megkötése'
        },
        {
          number: 4,
          description: 'Támogatási kérelem beküldése az MGFÜ pályázati felületén'
        },
        {
          number: 5,
          description: 'Támogatási kérelem ellenőrzése'
        },
        {
          number: 6,
          description: 'Döntés a támogatói okirat kiállításáról'
        },
        {
          number: 7,
          description: 'Támogatói okirat kiállítása'
        },
        {
          number: 8,
          description: 'Szakértő tanácsadói szolgáltatások megvalósítása'
        },
        {
          number: 9,
          description: 'Eredménytermékek feltöltése az MKIK Tőkealap-kezelő Zrt. pályázati felületére'
        },
        {
          number: 10,
          description: 'Eredménytermékek elbírálása'
        },
        {
          number: 11,
          description: 'Döntés a megvalósított szakértő tanácsadási szolgáltatásokról'
        },
        {
          number: 12,
          description: 'Eredménytermékek teljeskörű vagy részteljesítésű elfogadása'
        },
        {
          number: 13,
          description: 'Kifizetési igénylés beküldése az MGFÜ pályázati felületére'
        },
        {
          number: 14,
          description: 'Kifizetési igénylés elbírálása'
        },
        {
          number: 15,
          description: 'Döntés a pénzügyi alátámasztó dokumentumokról'
        },
        {
          number: 16,
          description: 'Utófinanszírozás Kedvezményezettek részére'
        }
      ]
    }
  },
  methods: {
    toggleIsActiveFirst() {
      this.isActiveFirst = !this.isActiveFirst
    },
    toggleIsActiveSecond() {
      this.isActiveSecond = !this.isActiveSecond
    },
    toggleIsActiveThird() {
      this.isActiveThird = !this.isActiveThird
    },
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.arrow-1 {
  position: relative;
  left: 285px;
}

.svgLeft {
  padding-left: 250px !important;
}

.arrow-2 {
  position: relative;
  left: 280px;
}

.button-title {
  position: relative;
}

.step-item {
  position: sticky;
  width: 50%;
  display: flex;
  align-items: flex-start;
  /* Függőleges igazítás */
  line-height: 30px;
  z-index: 2;
}

.step-button {
  height: auto !important;
  position: absolute;
  background-color: #00903c !important;
  /* Zöld szín */
}

.step-number {
  position: relative;
  font-weight: bold;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px !important;
  height: 30px !important;
  background-color: #00903c;
  /* Zöld szín */
  border-radius: 50%;
  z-index: 2;
}

.step-line-left {
  position: absolute;
  left: 22px;
  width: 15px;
  height: 90%;
  background: white;
  border-radius: 8px 8px 8px 8px;
  z-index: 1;
}

.step-line-right {
  position: absolute;
  left: 22px;
  width: 15px;
  height: 100%;
  background: white;
  border-radius: 8px 8px 8px 8px;
  z-index: 1;
}

.step-number svg {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
}

.step-description {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  /* Balra igazítás */
  word-wrap: break-word;
  /* Szó törés */
  overflow-wrap: break-word;
  /* Alternatív megoldás */
  margin-left: 10px;
  max-width: 400px;
  /* Példa maximális szélesség */
}

.responsive-iframe {
  overflow: auto;
  width: 100%;
  height: 80vh;
  border: none;
  max-width: 100%;
}

.buttonScroll {
  font-size: larger;
  border-radius: 12px;
  border: black;
  height: 160px;
  width: 100%;
  background-color: #f2f8fa;
}

.buttonScroll:focus {
  outline: none;
}

.box-Role {
  font-size: larger;
  border-radius: 12px;
  border: black;
  width: 100%;
  background-color: #f2f8fa;
}

.buttonRight {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.left-span {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
}

.modositas_icon {
  height: 20%;
  margin-right: 0px;
}

.B {
  font-weight: bold;
}

@media (max-width: 768px) {
  .step-item {
    width: 100%;
  }

  .step-description {
    max-width: 80%;
  }

  .responsive-iframe {
    height: 60vh;
    /* Vagy bármilyen más érték, ami megfelelő */
    overflow: auto;
    width: 100%;
    /* Biztosítja, hogy a szélesség 100% legyen */
  }
}

.red {
  color: red;
}

.p1-kkv {
  text-align: left;
  text-align: justify;
  /* Sorkizárt stílus */
}

.black {
  color: black !important;
}

.application-process-container {
  padding: 20px;
  background-color: #f2f8fa;
  /* Háttérszín */
  border-radius: 8px;
  /* Lekerekített sarkak */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Árnyék */
}

.wrapper-3 {
  color: black;
  border-radius: 10px 10px 0px 0px;
  background-image: url('../assets/img/Voucher_boritokep.svg');
  margin-left: 0px;
  margin-right: 0px;
}

.box-Role {
  font-size: larger;
  border-radius: 12px;
  border: black;
  width: 100%;
  background-color: #f2f8fa;
}

.download ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.top-title {
  color: black;
  font-weight: 400;
  font-size: 48px;
}

.buttonRight {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.download li {
  padding: 0;
  margin: 10px 0;
  background: #f2f8fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.download li:hover {
  background: #e5f0f5;
}

.greenText {
  color: #00903c;
  font-weight: bold;
  font-size: large;
}

.greenH {
  background-color: #00903c !important;
  color: #fff;
  border-radius: 10px;
}

.buttonFont {
  font-size: 1.7rem;
  top: 50px;
}

.wrapper-4 {
  background: #f2f8fa;
  border-radius: 0px 0px 12px 12px;
  margin-left: 0px;
}

.wrapper {
  background: #f2f8fa;
  border-radius: 12px;
}

.B {
  font-weight: bold;
}

body {
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  color: #333;
  margin: 0;
  padding: 0;
}

.home-container {
  padding: 20px;
}

.documents-section {
  margin: 20px 0;
}

.decorative-line {
  border: none;
  /* Eltávolítja az alapértelmezett stílust */
  height: 1px;
  /* Vonal vastagsága */
  background-color: #b9b9b9;
  /* Vonal színe */
  margin-top: 5px;
  /* Térköz a szöveg és a vonal között */
  margin-bottom: 10px;
  /* Térköz a vonal alatt, ha szükséges */
  width: 100%;
  /* Vonal szélessége */
}

.buttonScroll {
  width: 100%;
  padding: 15px 20px;
  background-color: #f2f8fa;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
}

.bigButton {
  width: 100%;
  height: 150px;
  background: #00903c;
  font-weight: 700;
  color: white;
  line-height: 32px;
  border-radius: 8px;
  outline: none;
  border: none;
  transition: background-color 0.3s ease;
}

.download ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.download li {
  padding: 10px;
  margin: 10px 0;
  background: #f2f8fa;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.greenText {
  color: #00903c;
  font-weight: bold;
}

.dspbox-Role {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

@media (max-width: 767px) {
  .buttonScroll {
    font-size: 1rem;
    height: 60px;
  }

  .buttonTOV {
    height: 180px;
  }

  .arrow-2 {
    left: 0px;
  }

  .arrow-1 {
    left: 0;
  }

  .svgLeft {
    padding-left: 6px !important;
  }

  .buttonFont {
    font-size: 1.8rem;
    top: 50px;
  }

  .bigButton {
    display: flex;
    /* Flexbox aktiválása */
    align-items: center;
    /* Vertikális középre igazítás */
    justify-content: space-between;
    /* Elek közötti távolság beállítása */
    width: 100%;
    /* Gomb szélessége 100% */
    padding: 10px;
    /* Gomb belső margója */
    box-sizing: border-box;
    /* A paddingot is figyelembe veszi a szélesség */
  }

  .greenH {
    display: flex;
    /* Flexbox aktiválása a h2 elemre is */
    align-items: center;
    /* Vertikális középre igazítás */
    margin: 0;
    /* Margó eltávolítása */
    width: 100%;
    flex-grow: 1;
    /* A h2 elem kitölti a rendelkezésre álló helyet */
  }

  .left-span {
    margin: 0 10px;
    /* Margó beállítása a szöveg körül */
  }

  .wrapper-3 {
    background-color: #f2f8fa;
    background-image: none;
  }

  .top-title {
    background-image: url('../assets/img/Voucher_boritokep.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 20px;
    color: black;
    font-weight: 350;
    border-radius: 10px 10px 0 0;
  }
}
</style>
